import React from 'react';
import { useHistory } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { Flex } from 'baseComponents/Layout';

const { Sider } = Layout;

const SideMenu = () => {
  const userRoles = JSON.parse(localStorage.getItem('userRoles') || '[]');
  const history = useHistory();
  const onSelect = (item) => {
    history.push(item.key);
  };

  const rootOrAdmin = userRoles.some(
    (item) => item.roleId === 'ROLE_ROOT' || item.roleId === 'ROLE_ADMIN'
  );

  return (
    <Sider
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
      }}
    >
      <Flex height="100%" flexDirection="column">
        <Menu
          onClick={onSelect}
          style={{ flex: 1 }}
          defaultSelectedKeys={['/patients']}
          selectedKeys={[history.location.pathname]}
          mode="inline"
        >
          <Menu.Item key="/patients">個案管理</Menu.Item>
          <Menu.Item key="/prescription-template">任務模板管理</Menu.Item>
          {rootOrAdmin && (
            <>
              <Menu.Item key="/staff">人員管理</Menu.Item>
              <Menu.Item key="/feedback-form">問卷題庫管理</Menu.Item>
              <Menu.Item key="/imu-position">IMU部位管理</Menu.Item>
              <Menu.Item key="/exercise-category">動作分類管理</Menu.Item>
              <Menu.Item key="/exercise">動作管理</Menu.Item>
            </>
          )}
        </Menu>
      </Flex>
    </Sider>
  );
};

SideMenu.propTypes = {};

SideMenu.defaultProps = {};

export default SideMenu;
